import { useState } from 'react';
import styles from './selectableListView.module.scss';
import { CheckBoxInput } from './checkboxInput';
import {HiArrowNarrowDown,HiArrowNarrowUp} from 'react-icons/hi';
import { parseUSDate } from '../list_view/listView';



export const SelectableListView = ({tblConf, data, listRef, selectedList, setSelectedList, customAction}) =>{
    const [sortingData, setSortingData] = useState(null);
    if(sortingData){
        data.sort((a, b) => {
            const valA = sortingData.valueExtractor(a);
            const valB = sortingData.valueExtractor(b);
            // Handle null/undefined values
            if (valA == null && valB == null) return 0;
            if (valA == null) return 1; // nulls go to end
            if (valB == null) return -1;
            // If valuesAreDates flag is set, parse and compare as dates
            if (sortingData.valuesAreDates) {
                const dateA = parseUSDate(valA);
                const dateB = parseUSDate(valB);
                
                if (dateA && dateB) {
                    // Both are valid dates - compare chronologically
                    const timeDiff = dateA.getTime() - dateB.getTime();
                    return sortingData.desc ? -timeDiff : timeDiff;
                }
                // If parsing fails, fall through to string comparison
            }
            // Check if both values are numbers
            const isNumeric = typeof valA === 'number' && typeof valB === 'number' && 
                             !isNaN(valA) && !isNaN(valB);
            
            if (isNumeric) {
                // Numeric comparison
                return sortingData.desc ? valB - valA : valA - valB;
            } else {
                // String comparison
                const strA = String(valA);
                const strB = String(valB);
                const comparison = strA.localeCompare(strB, undefined, { 
                    numeric: true, // Handles "10" > "2" correctly
                    sensitivity: 'base' // Case-insensitive
                });
                return sortingData.desc ? -comparison : comparison;
            }
        })
    }
    return <>
        <div className={styles.labels} style={tblConf.customRowStyling ?  Object.assign({}, ...tblConf.customRowStyling) : null}>
            <CheckBoxInput checked={false} onChangeAction={{method: (checked)=>{
                    const allCheckBoxes = listRef.current.getElementsByClassName("selectableListCheckBox");
                    for(let i = 0; i < allCheckBoxes.length; i++){
                        allCheckBoxes[i].checked = checked;
                    }
                    setSelectedList(checked?["selectAll"]:[]);
                }, parameter:"selectAll" }} />
            {
                tblConf.columns.map((column)=>{
                    return <div key={column.name}  style={column.customFlexGrow ? {flexGrow: column.customFlexGrow} : null}>
                        {column.lbl}
                        {column.sortable?
                            <span className={`${styles.labelArrow} ${sortingData && sortingData.by === column.name ? styles.labelArrowActive : styles.labelArrowInactive}`} onClick={
                                ()=>{
                                    setSortingData(prev => {
                                        if(!prev || prev.by !== column.name){
                                            return {by: column.name, 
                                                    valueExtractor: column.valueExtractor && !column.sortByRawValue ? column.valueExtractor : column.valueGenerator && !column.sortByRawValue ? column.valueGenerator : (rawData)=>{return rawData[column.name]},
                                                    valuesAreDates: column.valuesAreDates || false,
                                                    desc: true}
                                        }
                                        return {...prev, desc: !prev.desc}
                                    })
                                }} >{(!sortingData || sortingData.by !== column.name) || sortingData.desc ? <HiArrowNarrowUp /> : <HiArrowNarrowDown />}</span>
                        :
                            null
                        }
                    </div>
                })
            }
        </div>
        {
            data.map((item, index)=>{
                return <div key={index} className={styles.row} style={tblConf.customRowStyling ?  Object.assign({}, ...tblConf.customRowStyling) : null} >
                    <CheckBoxInput checked={false} onChangeAction={{method: (checked, id)=>{
                        let newArr = [...selectedList];
                        if(selectedList.length > 0 && selectedList[0] === "selectAll"){
                            newArr[0] = "ignoreFollowing";
                            newArr.push(id);
                        }else{
                            
                            if(selectedList.length > 0 && selectedList[0] !== "ignoreFollowing" && checked){
                                newArr.push(id);
                            }else if(selectedList.length > 0 && selectedList[0] === "ignoreFollowing" && !checked){
                                newArr.push(id);
                            }else{
                                if(newArr.length > 0 && newArr[0] === "ignoreFollowing" && checked){
                                    newArr = newArr.filter(item => item !== id);
                                    if(newArr.length === 1){
                                        newArr=["selectAll"];
                                    }
                                }else if(checked){
                                    newArr.push(id);
                                }else{
                                    newArr = newArr.filter(item => item !== id);
                                }
                            }
                        }
                        setSelectedList(data.length < newArr.length ? [] : newArr);
                    }, parameter:item[tblConf.idColumnName] }} 
                    className="selectableListCheckBox"  />
                    {tblConf.columns.map((column)=>{
                        const columnName = column.name;
                        const val = column.valueExtractor ? column.valueExtractor(item) : item[columnName];
                        return <div key={`${index}${columnName}`} className={`${column.customClassName ? column.customClassName(item) : ''}`} 
                            onClick={
                                ()=>{
                                    if(column.customActionOnceClicked){
                                        customAction(item);
                                    }else if(column.onClick){
                                        column.onClick(item);
                                    }
                                }
                            }
                            style={column.conditionalStyling ? Object.assign({}, ...column.conditionalStyling(val)):null}
                        >
                            <span style={column.conditionalValueStyling ? Object.assign({}, ...column.conditionalValueStyling(val)):null}>{val}</span>
                        </div>
                    })}
                </div>
            })
        }
    </>
}
    
  